"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var AggregationControl_styles_1 = require("./AggregationControl.styles");
var aggregations = [
    "minutes_1",
    "minutes_5",
    "hour",
    "day",
    "month",
];
var labels = {
    "minutes_1": "Minute",
    "minutes_5": "5 Min.",
    "hour": "Stunde",
    "day": "Tag",
    "month": "Monat",
    "year": "Jahr",
};
var AggregationControl = function (_a) {
    var _b = _a.label, label = _b === void 0 ? "Pro" : _b, value = _a.value, onChange = _a.onChange, _c = _a.className, className = _c === void 0 ? "" : _c;
    var styles = (0, AggregationControl_styles_1.useStyles)();
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(styles.component, " ").concat(className) }, { children: [(label === null || label === void 0 ? void 0 : label.length) > 0 ? (0, jsx_runtime_1.jsx)("div", __assign({ className: styles.label }, { children: label })) : null, (0, jsx_runtime_1.jsx)("div", __assign({ className: styles.options }, { children: aggregations.map(function (aggregation) {
                    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: aggregation === value ? styles.selected : styles.button, onClick: function () { return onChange(aggregation); } }, { children: labels[aggregation] }), aggregation));
                }) }))] })));
};
exports.default = AggregationControl;
